import { styled } from '@mui/material/styles';
import { Table } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Storage } from 'react-jhipster';

export const StyledTable = styled(Table)(({ theme }) => ({
  '&.MuiTable-root': {
    tableLayout: 'fixed',
    width: '100%',
  },
}));

export const labelStyle = {
  display: 'inline-block',
  padding: '6px 12px',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '1.42857143',
  textAlign: 'center' as const, // set textAlign to one of the valid TextAlign values
  whiteSpace: 'nowrap' as const, // set whiteSpace to one of the valid WhiteSpace values
  verticalAlign: 'middle' as const, // set verticalAlign to one of the valid VerticalAlign values
  cursor: 'pointer',
  backgroundColor: '#f5f5f5',
  border: '1px solid #ccc',
  borderRadius: '4px',
  WebkitUserSelect: 'none' as const, // set WebkitUserSelect to one of the valid UserSelect values
  MozUserSelect: 'none' as const, // set MozUserSelect to one of the valid UserSelect values
  msUserSelect: 'none' as const, // set msUserSelect to one of the valid MsUserSelect values
  userSelect: 'none' as const, // set userSelect to one of the valid UserSelect values
};

export const inputStyle = {
  display: 'none',
};

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: '0.55rem',
    fontWeight: 'bold',
    textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    overflow: 'hidden',
    textOverflow: 'clip',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.55rem',
    textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    overflow: 'hidden',
    textOverflow: 'clip',
    wordWrap: 'break-word',
  },
}));
